import React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import AnalyticsIcon from '@mui/icons-material/Analytics';
import PeopleIcon from "@mui/icons-material/People";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

const buttonStyles = {
  "&.Mui-selected": {
    backgroundColor: "#2e8b57",
  },
  "&.Mui-focusVisible": {
    backgroundColor: "#2e8b57",
  },
  ":hover": {
    backgroundColor: "#FEE7D1",
  },
};

export const ListItem = ({ IconComponent, primary, onClick }) => (
  <ListItemButton sx={buttonStyles} onClick={onClick}>
    <ListItemIcon>
      <IconComponent />
    </ListItemIcon>
    <ListItemText primary={primary} />
  </ListItemButton>
);

export function MainListItems() {
  const navigate = useNavigate();
  const listItems = [
    { IconComponent: PeopleIcon, primary: "Users", path: "/dashboard" },
    { IconComponent: DashboardIcon, primary: "Concerns", path: "/concerns" },
    { IconComponent: ViewCarouselIcon, primary: "Articles", path: "/articles" },
    { IconComponent: AnalyticsIcon, primary: "Analytics", path: "/analytics"}
  ];

  return (
    <React.Fragment>
      {listItems.map(({ IconComponent, primary, path }) => (
        <ListItem
          key={primary}
          IconComponent={IconComponent}
          primary={primary}
          onClick={() => navigate(path)}
        />
      ))}
    </React.Fragment>
  );
}

export function SecondaryListItems() {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleLogout = () => {
    localStorage.removeItem("authToken");
    navigate("/");
  };

  return (
    <React.Fragment>
      <ListItem
        IconComponent={LogoutIcon}
        primary="Logout"
        onClick={handleOpen}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle sx={{ width: "400px" }} id="alert-dialog-title">
          {"Logout"}
        </DialogTitle>
        <DialogContent>Are you sure to logout?</DialogContent>
        <DialogActions>
          <Button
            sx={{
              color: "#F2A040",
              borderColor: "#F2A040",
              ":hover": {
                borderColor: "#F2A040",
                backgroundColor: "white",
              },
            }}
            variant="outlined"
            onClick={handleClose}
          >
            Disagree
          </Button>
          <Button
            sx={{
              backgroundColor: "#F2A040",
              borderColor: "#F2A040",
              boxShadow: "none",
              ":hover": {
                borderColor: "#F2A040",
                backgroundColor: "#F2A040",
                color: "#ffffff",
                boxShadow: "none",
              },
            }}
            variant="contained"
            onClick={handleLogout}
            autoFocus
          >
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}